import { useEffect, useState, forwardRef } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import { useTranslation } from 'react-i18next';
import { RouteConstants } from '../../constants/RouteConstants';
import { NewOrganizationFormLayout, sessionTokenSchema } from '../../util/constants';

import LoaderContainer from '../shared/loaderContainer/LoaderContainer';

import Card from '../../components/shared/cards/Card';
import { HTTP_STATUS } from '../../http/constants/http.status';

import { SettingIcon } from '../../assets/components/svgs';
import { init } from 'i18next';
import { getSessionTokenSettings } from '../../http/user-management-services';
import DynamicFormFieldRenderer from '../Reusable/DynamicFormFieldRenderer';
import ActionButtons from './ActionButtons';
import { handleSettingsValidation, validateSettingsSave } from './Utils';
import { AppConstants } from '../../constants/AppConstants';
import { filter } from 'lodash';
import { setBreadcrump } from '../../app/organizationReducer';

const SessionTokenSettings = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [formData, setFormData] = useState<any>({});
  const [initialData, setInitialData] = useState<any>({});
  const [formError, setFormError] = useState<any>({});

  const [sessionSelectedItems, setSelectedSessionItems] = useState<any>([]);

  useEffect(() => {
    const init = async () => {
      const sessionTokenSettingsResp = await getSessionTokenSettings();
      if (sessionTokenSettingsResp.status === HTTP_STATUS.HTTP_OK) {
        const { data } = sessionTokenSettingsResp;
        const { sessionQuotaExhaustedBehaviour } = data;
        const selectedSessionQuota = filter(AppConstants.SESSION_QUOTA_OPTIONS, {
          sessionQuotaExhaustedBehaviour: sessionQuotaExhaustedBehaviour
        });
        setFormData({ ...data, sessionQuotaDisplay: selectedSessionQuota[0].sessionQuotaDisplay });
        setSelectedSessionItems(
          filter(AppConstants.SESSION_QUOTA_OPTIONS, {
            sessionQuotaExhaustedBehaviour: sessionQuotaExhaustedBehaviour
          })
        );
        setInitialData({
          ...data,
          sessionQuotaDisplay: selectedSessionQuota[0].sessionQuotaDisplay
        });
        setIsLoading(false);
      }
    };
    dispatch(
      setBreadcrump([
        {
          key: RouteConstants.ROUTE_SECURITY_SETTINGS,
          label: t('T_ACCESS_MANAGEMENT_SETTINGS')
        }
      ])
    );

    init();
  }, []);

  const postUpdateSettings = () => {
    const { sessionQuotaExhaustedBehaviour } = formData;
    const selectedSessionQuota = filter(AppConstants.SESSION_QUOTA_OPTIONS, {
      sessionQuotaExhaustedBehaviour: sessionQuotaExhaustedBehaviour
    });
    setFormData({ ...formData, sessionQuotaDisplay: selectedSessionQuota[0].sessionQuotaDisplay });
    setInitialData({
      ...formData,
      sessionQuotaDisplay: selectedSessionQuota[0].sessionQuotaDisplay
    });
    setIsReadOnly(true);
    setIsLoading(false);
  };

  const resetSettings = () => {
    const { sessionQuotaExhaustedBehaviour } = initialData;
    setFormData(initialData);
    setSelectedSessionItems(
      filter(AppConstants.SESSION_QUOTA_OPTIONS, {
        sessionQuotaExhaustedBehaviour: sessionQuotaExhaustedBehaviour
      })
    );
    setFormError({});
  };

  const handleValidation = () => {
    let formError = handleSettingsValidation(formData, sessionTokenSchema, t);
    setFormError(formError);
    return formError;
  };

  const validateSave = () => {
    return validateSettingsSave(formData, sessionTokenSchema);
  };

  const onSessionQuotaChange = (items: any) => {
    setSelectedSessionItems(items);
    setFormData({
      ...formData,
      sessionQuotaDisplay: items.length ? items[0].value : 'Destroy Next Expiring',
      sessionQuotaExhaustedBehaviour: items.length ? items[0].sessionQuotaExhaustedBehaviour : ''
    });
  };

  const rootProps = {
    onSessionQuotaChange: onSessionQuotaChange,
    onSessionQuotaSelectedItems: sessionSelectedItems
  };

  return (
    <LoaderContainer isLoading={isLoading}>
      <div className="flex w-3/5 flex-col overflow-visible px-2 py-3">
        <Card
          title={t('T_SESSION_TOKEN_CARD_SETTINGS')}
          icon={SettingIcon}
          alt={'T_SESSION_TOKEN_CARD_SETTINGS'}
          height={''}
          width={''}
          className=""
          actions={
            <ActionButtons
              settingKey={'sessionToken'}
              formData={formData}
              initialData={initialData}
              callback={postUpdateSettings}
              setIsReadOnly={setIsReadOnly}
              setIsLoading={setIsLoading}
              isReadOnly={isReadOnly}
              resetSettings={resetSettings}
              handleValidation={handleValidation}
              validateSave={validateSave}
            />
          }
        >
          <div className="mb-5 flex w-full flex-col flex-wrap">
            <div className="flex w-full flex-wrap">
              <DynamicFormFieldRenderer
                dynamicFormData={sessionTokenSchema}
                formData={formData}
                setFormData={setFormData}
                formError={formError}
                setFormError={setFormError}
                layout={NewOrganizationFormLayout.twoColumn}
                editable={!isReadOnly}
                disabled={isReadOnly}
                rootProps={rootProps}
              />
            </div>
          </div>
          {/* <ActionButtons
            settingKey={'sessionToken'}
            formData={formData}
            initialData={initialData}
            callback={postUpdateSettings}
            setIsReadOnly={setIsReadOnly}
            setIsLoading={setIsLoading}
            isReadOnly={isReadOnly}
            resetSettings={resetSettings}
            handleValidation={handleValidation}
            validateSave={validateSave}
          /> */}
        </Card>
      </div>
    </LoaderContainer>
  );
};

export default SessionTokenSettings;
